export default __webpack_public_path__ + "b9e7d8458bfd5f7d7cbbaff34930111d.svg";